import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";

import { Sizes, Colors, Typography } from "../../styles";

const ParentMenu = ({menuItems, setActiveMenuItems, setSubMenuIsOpen, subMenuIsOpen, expanded, setExpanded, inactiveLanguage }) => {

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.largeMenu})`,
	});

	const renderParentLinks = (menuItems) => {
		if (menuItems.error_data) return null;

		return (
			<ParentLinks className="parent-links">
				{
					menuItems.map(item => {
						const isOpen = item.id === expanded;
						return (
							<li key={item.id}
							>
								<button
									className={isOpen ? "active" : ""}
									onMouseDown={(event) => handleClick(item.id, isOpen, event)}
									onFocus={(event) => handleClick(item.id, isOpen,event)}
								>
									{item.title}
								</button>
							</li>
						)
					})
				}
			</ParentLinks>
		)
	}

	const handleClick = (id, isOpen, event) => {
		event.preventDefault()
		event.stopPropagation()
		const activeMenu = findActiveMenu(menuItems, id);
		setActiveMenuItems(isOpen ? {} : activeMenu);
		setExpanded(isOpen ? false : id);
		setSubMenuIsOpen( isOpen ? false : true);
	}

	const handleMobileMenuBtnClick = () => {
		if (menuItems.error_data === 0) {
			return;
		}
		setSubMenuIsOpen(currentValue => !currentValue);
	}

	const findActiveMenu = (array, id) => {
		const filteredArray =  array.filter(obj => {
			return obj.id === id;
		});

		return filteredArray[0];
	}

	const renderMobileMenuButtonIcon = () => {
		if (!subMenuIsOpen) {
			return (
				<img
					src={`${mainScript.assetPath}images/svg/icons/icon-ham-menu-green.svg`}
					alt=""
					width="25.31px"
					height="25.31px"
				/>
			)
		}

		return (
			<img
				src={`${mainScript.assetPath}images/svg/icons/icon-close-green.svg`}
				alt=""
				width="25.31px"
				height="25.31px"
			/>
		)
	}

	const renderMobileMenuButton = () => {
		if (isDesktopOrLaptop) return null;

		if (menuItems.error_data) {
			return <LangButtonMobile href={inactiveLanguage?.url}>{inactiveLanguage?.code}</LangButtonMobile>;
		}

		return (
			<MobileMenuButton
				onClick={() => handleMobileMenuBtnClick()}
			>
				{renderMobileMenuButtonIcon()}
			</MobileMenuButton>
		)

	}

	const logoLinkHref = () => {
		return inactiveLanguage?.code === "fr" ? "https://futurpreneur.ca" : "https://futurpreneur.ca/fr";
	}
	
	return (
		<>
			<div className="main-grid">
				<div className="main-grid__margin"></div>
				<div className="main-grid__body">
					<HeaderUpperWrapper >
						<MenuUpper aria-label="upper menu" className="main-grid__body upper-menu">
							<LogoContainer>
								<Logo href={logoLinkHref()} aria-label="go to futurpreneur's main site">
									<img
										src={`${mainScript.assetPath}images/svg/logos/main-logo.svg`}
										alt=""
									/>
								</Logo>
							</LogoContainer>
							<ButtonsContainer>
								<LangButton href={inactiveLanguage?.url}>{inactiveLanguage?.code}</LangButton>
							</ButtonsContainer>
						</MenuUpper>
					</HeaderUpperWrapper>
					{
						menuItems.error_data && isDesktopOrLaptop
							? null
							: <ParentMenuContainer >
								<LogoMobile href={logoLinkHref()} aria-label="go to futurpreneur's main site">
									<img
										src={`${mainScript.assetPath}images/svg/logos/main-logo.svg`}
										alt=""
									/>
								</LogoMobile>
								{renderParentLinks(menuItems)}
								{renderMobileMenuButton()}
							</ParentMenuContainer>
					}
				</div>
				<div className="main-grid__margin"></div>
			</div>
		</>
	)

}

ParentMenu.propTypes = {
	menuItems: PropTypes.array.isRequired,
	setActiveMenuItems: PropTypes.func.isRequired,
	setSubMenuIsOpen: PropTypes.func.isRequired,
	subMenuIsOpen: PropTypes.bool.isRequired,
	expanded: PropTypes.number.isRequired,
	setExpanded: PropTypes.func.isRequired,
	inactiveLanguage: PropTypes.object.isRequired,
};

export default ParentMenu;

const HeaderUpperWrapper = styled.div`
	display: none;

	@media only screen and (min-width: ${Sizes.screens.largeMenu}) {
		display: block;
		padding: 2.6rem 0 0;
	}
`;

const MenuUpper = styled.nav`
	display: flex;
	justify-content: space-between;
`;

const ButtonsContainer = styled.div`
	display: flex;
	column-gap: 2rem;
	align-items: center;
`;

const LangButton = styled.a`
	padding: unset;
	background-color: unset;
	position: relative;
	color: ${Colors.base.black};
	align-self: center;
	text-transform: uppercase;
	font-family: ${Typography.fontFamily.base};
	font-weight: ${Typography.fontWeight.bold};

	&::after {
		content: '';
		position: absolute;
		top: 2rem;
		left: 0;
		height: 0.2rem;
		width: 0;
		transition: width .2s ease-in-out;
		background-color: ${Colors.fp.pineGreen};
	}

	&:hover,
	&:focus {
		@media only screen and (min-width: ${Sizes.screens.largeMenu}) {
			&::after {
				content: '';
				width: 100%;
			}
		}
	}
`;

const LangButtonMobile = styled.a`
	padding: unset;
	background-color: unset;
	position: relative;
	color: ${Colors.base.black};
	align-self: center;
	text-transform: uppercase;
	font-family: ${Typography.fontFamily.base};
	font-weight: ${Typography.fontWeight.bold};
`;

const ParentMenuContainer = styled.nav`
    padding: 2.6rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 2rem;

	@media only screen and (min-width: ${Sizes.screens.largeMenu}) {
		align-items: flex-end;
		padding: 3rem 0 2rem 0;
	}
`;

const LogoContainer = styled.div`
`;

const Logo = styled.a`
    display: block;
	flex-shrink: 0;
	flex-basis: 20.4rem;

    img {
        width: 100%;

        @media only screen and (min-width: ${Sizes.screens.largeMenu}) {
			width: 20.4rem;
        }
    }
`;

const LogoMobile = styled.a`
	display: block;
	flex-shrink: 0;
	flex-basis: 17.2rem;

	img {
		width: 17.2rem;
	}
`;

const ParentLinks = styled.ul`
    list-style-type: none;
    margin: unset;
    padding: unset;
    display: none;

    @media only screen and (min-width: ${Sizes.screens.largeMenu}) {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
		justify-content: space-between;
		width: 100%;
    }

    li {
        margin: unset;

		&:last-of-type {
			position: relative;
		}
    }

    button {
        padding: unset;
        background-color: unset;
        color: ${Colors.base.black};
        position: relative;
		line-height: 1.9rem;
		font-family: ${Typography.fontFamily.base};
		font-weight: ${Typography.fontWeight.bold};

        &::after {
            content: "";
            position: absolute;
            top: 1.8rem;
            left: 0;
            height: 0.2rem;
            width: 0;
            transition: width .2s ease-in-out;
            background-color: ${Colors.fp.pineGreen};
			opacity: 1;
			visibility: visible;
			padding: unset;
			transform: unset;
        }

        &:hover,
		&:focus, 
		&.active {
            &::after {
				content: "";
                width: 100%;
            }
        }
    }
`;

const MobileMenuButton = styled.button`
    padding: unset;
    background-color: unset;

    @media only screen and (min-width: ${Sizes.screens.largeMenu}) {
        display: none;
    }

    &::after {
        content: none;
    }

    &:hover,
    &:focus {
        padding-right: 0;

        &::after {
            content: none;
        }
    }
`;
